import React, { Component } from "react";
import queryString from "query-string";

//import ExportJpgSvg from "../../images/icons/export-jpg.svg";
import ExportPdfSvg from "../../images/icons/export-pdf.svg";
import Pattern from "../Pattern";
import { patternsByIds } from "../../constants/patterns";
//import { surfaceBrandsByIds } from "../../constants/surfaceBrands";



import env from "../../constants/env";
import { PDF, IMAGE, BACKGROUNDIMAGE } from "../../constants/modelExportTypes";
import Button from "../shared/Button";
import Modal from "./Modal";


const API_URL = `${env.REACT_APP_FUNCTIONS_URL}/api/models/export`;

class DownloadFolderModal extends Component {
  state = {
    downloadType: PDF
  };

  constructor(props) {
    super(props);

    this.handleCreate = this.handleCreate.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(downloadType) {
    this.setState({ downloadType });
  }

  handleCreate() {
    this.props.handleCreateModelExport({
      userFullname: this.props.userFullname,
      userCompany: this.props.userCompany,
      folderTitle: this.props.folderTitle,
      surfaceId: this.props.surfaceId,
      patternId: this.props.patternId,
      patternConfig: this.props.patternConfig,
      imagePanel: this.props.imagePanel
    });
  }

  render() {
    const { modelExport, lng, handleCloseModal, t } = this.props;
    const { id } = modelExport || {};
    const { downloadType } = this.state;
    let url;

    if (id) {
      const query = queryString.stringify({ lng });
      url = `${API_URL}/${id}.${downloadType}?${query}`;
    }

    return (
      <Modal
        title={t("modals:downloadModalTitle")}
        handleClose={handleCloseModal}
      >
        <div className="flex">
          <div
            className="w-33 pv5 pl0 br b--black tc"
              onClick={() => this.handleClick(IMAGE)}>
            <div>
                <div className="radio__field pl0">
                  <input
                    type="radio"
                    value={IMAGE}
                    checked={downloadType === IMAGE}
                    onChange={() => {}}
                  />
                  <label htmlFor="hdImages">
                      {this.props.t("modals:downloadModalProductPerforatedSurface")}
                  </label>
                </div>
            </div>
            <div className="ph6">
                <div
                  className="composition__zone mt3 tc"
                  style={{width: `130px`, height: `155px`  }}
                >
                    <div
                      className="composition__img"
                      style={{backgroundImage: `url(${this.props.imagePanel})` }}
                    />
                    <div className="composition__svg">
                    <Pattern
                      keySeed={this.props.patternId}
                      config={this.props.patternConfig}
                      pattern={patternsByIds[this.props.patternId]}
                      scaled
                    />
                    </div>
                </div>
            </div>
          </div>

          <div
            className="w-33 pv5 br b--black tc"
              onClick={() => this.handleClick(BACKGROUNDIMAGE)}>
            <div>
              <div className="radio__field">
                <input
                  type="radio"
                  value={BACKGROUNDIMAGE}
                  checked={downloadType === BACKGROUNDIMAGE}
                  onChange={() => {}}
                />
                <label htmlFor="hdImages">
                  {this.props.t("modals:downloadModalProductNonPerforatedSurface")}
                </label>
              </div>
            </div>
            <div className="ph6">
                <div
                  className="composition__zone mt3 tc"
                  style={{width: `130px`, height: `155px`  }}
                >
                    <div
                      className="composition__img"
                      style={{backgroundImage: `url(${this.props.imagePanel})` }}
                    />
                </div>
            </div>
          </div>

          <div className="w-34 pv5 tc" onClick={() => this.handleClick(PDF)}>
            <div className="radio__field">
              <input
                type="radio"
                value={PDF}
                checked={downloadType === PDF}
                onChange={() => {}}
              />

              <label htmlFor="techSpecs">
                {this.props.t("modals:downloadModalProductPageButton")}
              </label>
            </div>

            <div className="mt3">
              <img
                src={ExportPdfSvg}
                alt={t("modals:downloadModalExportButton")}
                width={"110px"}
              />
            </div>
          </div>
        </div>

        <div className="pa2 bt b--black tc">
          <button className="button mr2" onClick={handleCloseModal}>
            {this.props.t("common:cancelButton")}
          </button>

          {id ? (
            <a
              className="button"
              href={downloadType===BACKGROUNDIMAGE ? '../..' + this.props.imagePanel : url}
              download={id}
              rel="noopener noreferrer"
            >
              {this.props.t("modals:downloadModalDownloadButton")}
              <i className="button__icon i-arrow-right f6" />
            </a>
          ) : (
            <Button
              onClick={this.handleCreate}
              label={t("modals:downloadModalGenerateButton")}
              icon="i-arrow-right f6"
            />
          )}
        </div>
      </Modal>
    );
  }
}

export default DownloadFolderModal;



// WEBPACK FOOTER //
// ./src/components/modals/DownloadFolderModal.js